module.exports = __webpack_public_path__ + "static/media/CHANGELOG.f13f3ef4.md";